import React, { InputHTMLAttributes } from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import s from './BaseInput.scss';

export interface Props extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'required' | 'min' | 'max'
> {
  isRequired?: boolean;
  biData?: BiEvent;

  // Removing the `string` option from min/max for a cleaner interface
  min?: number;
  max?: number;
}

const BaseInput = React.forwardRef<HTMLInputElement, Props>(
  ({ isRequired, className, ...rest }, ref) => {
    return (
      <BiInput
        className={c(s['input'], className)}
        required={isRequired}
        innerRef={node => {
          if (isFunction(ref)) {
            ref(node as any);
          } else if (ref) {
            ref.current = node as any;
          }
        }}
        {...rest}
      />
    );
  }
);
BaseInput.displayName = 'BaseInput';

export default BaseInput;
